export const HelpText = `

Please note that this is just the general help section for answers that didn't fit elsewhere.
Look out for question mark buttons for more context-specific help.

### What are those triangles on the map?

Those are segment labels. You can click on it to select the segment.
If a segment is considered active by the robot - meaning that it is part of the robots current task - the triangle will
point down. Otherwise, it will point up.

If you zoom in on a segment label, it will display the segment ID, its name and also its size in m².

### How do I open the controls of the home page on mobile?

Just tap on the bar at the bottom of the screen.

### How do I get the coordinates/parameters of segments/zones/go-to locations to trigger them via MQTT/REST?

Simply configure/select the segments/zones/go-to locations like you'd normally do and then long-press the button that would start the action.
This will bring up a dialog providing you with everything you'll need.

`;
